import { object, number } from 'yup';

import useCredentials from 'api/hook/useCredentials';

import { baseAxios, handleError } from 'api';
import { useQuery } from '@tanstack/react-query';

// eslint-disable-next-line no-unused-vars
const PolicyStatScheme = object({
  total: number().required(),
  totalSuccess: number().required(),
  totalExp3m: number().required(),
  totalExp6m: number().required(),
  totalExp1y: number().required(),
  totalExp15m: number().required(),
});

/**
 * @typedef {import('yup').InferType<typeof PolicyStatScheme>} TPolicyStat
 *
 * @return {import('@tanstack/react-query').UseQueryResult<TPolicyStat, any>}
 */
export function usePolicyStat(today) {
  const authAxios = useCredentials();

  return useQuery({
    queryKey: ['policyStat', today],
    queryFn: () => baseAxios(authAxios, { url: 'policy/stat' }),
    onError: handleError,
    retry: false,
    initialData: {
      total: 0,
      totalSuccess: 0,
      totalExp3m: 0,
      totalExp6m: 0,
      totalExp1y: 0,
      totalExp15m: 0,
    },
  });
}
